<template>
  <div class="vertical-nav bg-main" :class="{active: isActive}" id="sidebar">
    <select @change="changeSelectedGatehouse" id="gatehouse" class="form-select rounded-0" :value="$store.getters.selectedGatehouse.slug">
      <option v-for="gatehouse in $store.getters.gatehouses" :value="gatehouse.slug">{{ gatehouse.name }}</option>
    </select>
    <router-link class="nav-link px-4 text-nowrap" :to="`/${$store.getters.selectedGatehouse.slug}/vehicle-entries`">
      {{ $t("navbar.vehicles") }}
    </router-link>
    <router-link class="nav-link px-4 text-nowrap" :to="`/${$store.getters.selectedGatehouse.slug}/vehicle-entries/add`">
      {{ $t("navbar.vehicleAdd") }}
    </router-link>
    <router-link class="nav-link px-4 text-nowrap" :to="`/${$store.getters.selectedGatehouse.slug}/guestbooks`">
      {{ $t("navbar.guestbooks") }}
    </router-link>
    <router-link class="nav-link px-4 text-nowrap" :to="`/${$store.getters.selectedGatehouse.slug}/guestbooks/add`">
      {{ $t("navbar.guestbookAdd") }}
    </router-link>
    <router-link class="nav-link px-4 text-nowrap" :to="`/${$store.getters.selectedGatehouse.slug}/calendar`">
      {{ $t("navbar.calendar") }}
    </router-link>
    <router-link class="nav-link px-4 text-nowrap" to="/profile">
      {{ $t("navbar.myProfile") }}
    </router-link>
    <router-link class="nav-link px-4 text-nowrap" to="/logout">
      {{ $t("navbar.logout") }}
    </router-link>
    <ChangeLang class="mx-4" />
    <button v-if="!isActive" id="sidebarCollapse" type="button" class="btn btn-light bg-primary shadow-sm w-100 rounded-0 fw-bold text-white position-absolute bottom-0" @click="toggleMenu()">
      <small class="text-uppercase font-weight-bold">
        <span>Zavřít</span>
      </small>
    </button>
  </div>
  <div class="page-content p-3" :class="{active: isActive}" id="content">
    <button v-if="isActive" id="sidebarCollapse" type="button" class="btn btn-light bg-primary shadow-sm px-4 mb-4" @click="toggleMenu()">
      <small class="text-uppercase font-weight-bold">
        <span>Otevřít</span>
      </small>
    </button>
  </div>
</template>


<script>
import ChangeLang from "@/components/ChangeLang.vue"
export default {
  components: {
    ChangeLang
  },
  data() {
    return {
      isActive: true
    }
  },
  methods: {
    // Sidebar toggle behavior
    toggleMenu() {
      this.isActive = !this.isActive;
    },
    changeSelectedGatehouse(event) {
      this.$store.commit("selectGatehouse", event.target.value)
    }
  }
}
</script>


<style scoped lang="scss">
@import "@/scss/abstracts/variables";

.vertical-nav {
  min-width: 17rem;
  width: 17rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.4s;
  background-color: white;
  z-index: 10000;
}

.page-content {
  width: calc(100% - 17rem);
  margin-left: 17rem;
  transition: all 0.4s;
}

/* for toggle behavior */

#sidebar.active {
  margin-left: -17rem;
}

#content.active {
  width: 100%;
  margin: 0;
}

@media (max-width: 768px) {
  #sidebar {
    margin-left: -17rem;
  }
  #sidebar.active {
    margin-left: 0;
  }
  #content {
    width: 100%;
    margin: 0;
  }
  #content.active {
    margin-left: 17rem;
    width: calc(100% - 17rem);
  }
}
</style>